"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LottieLoader = _interopRequireDefault(require("./LottieLoader.scss"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LottieLoader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LottieLoader, _Component);

  function LottieLoader(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      component: null
    };
    return _this;
  }

  var _proto = LottieLoader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      component: require('react-lottie')["default"]
    });
    var skipOnDev = this.props.skipOnDev;

    if (process.env.NODE_ENV === 'development' && skipOnDev) {
      var onFinish = this.props.onFinish;
      onFinish();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onFinish = _this$props.onFinish,
        animationData = _this$props.animationData,
        loop = _this$props.loop,
        label = _this$props.label,
        height = _this$props.height,
        width = _this$props.width;
    var component = this.state.component;
    var Comp = component;
    var defaultOptions = {
      loop: loop || false,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    var componentProps = {
      options: defaultOptions,
      height: height || 450,
      isStopped: false,
      isPaused: false
    };

    if (width) {
      componentProps.width = width;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _LottieLoader["default"].root,
      "data-aid": "lottie-loader"
    }, Comp && /*#__PURE__*/_react["default"].createElement(Comp, _extends({
      eventListeners: [{
        eventName: 'complete',
        callback: onFinish || _lodash.noop
      }]
    }, componentProps)), label ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _LottieLoader["default"].label
    }, label) : null);
  };

  return LottieLoader;
}(_react.Component);

var _default = LottieLoader;
exports["default"] = _default;